<template>
  <v-data-table
    :headers="headersTarefas"
    :items="tasks"
    item-key="municipioTarefaId"
    class="elevation-1 evidenciada"
    loading-text="Obtendo informações ..."
    hide-default-footer
    disable-pagination
    :loading="loading"
  >
  </v-data-table>
</template>

<script>
export default {
  props: {
    tasks: { type: Array, required: true },
    loading: { type: Boolean, required: false, default: true }
  },
  data () {
    return {
      headersTarefas: [
        { text: 'Nome da tarefa', value: 'nome' },
        { text: 'Status', value: 'status' }
      ]
    }
  }
}
</script>
